import { fetchIfLoggedIn } from '../utils.js'

export const FETCH_NOTIFICATION_MEDIUMS = 'FETCH_NOTIFICATION_MEDIUMS'
export const GET_IDS = 'GET_IDS'
export const GET_IDS_FLUSH = 'GET_IDS_FLUSH'

export const fetchNotificationMediums = () => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: FETCH_NOTIFICATION_MEDIUMS,
      method: 'get',
      path: '/v1/notification-service/notificationmediums',
    })
  )
}

export const getIDs = (id, channelNameList) => dispatch => {
  return dispatch(
    fetchIfLoggedIn({
      actionType: GET_IDS,
      method: 'post',
      path: `/v1/notification-service/notificationmediums/${id}/channels/validate/names`,
      postBody: channelNameList,
    })
  )
}
